var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"30px","padding-top":"4px","border-top":"1px solid"}},[_c('el-form-item',{attrs:{"prop":_vm.elementDefinition.key}},[_c('h4',[_vm._v(_vm._s(_vm.elementDefinition.label))]),_vm._v(" "),_c('span',{staticStyle:{"line-height":"1.6!important"},domProps:{"innerHTML":_vm._s(_vm.instructions)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }